import { PLATFORM } from "aurelia-pal";
import { RouteConfig } from "aurelia-router";

export const AxxessIntelligenceRoutes: RouteConfig[] = [
    {
        name: "root",
        route: "",
        redirect: "axxess-intelligence-page"
    },
    {
        name: "axxess-intelligence-page",
        route: "axxess-intelligence-page",
        moduleId: PLATFORM.moduleName(
            "./axxess-intelligence-page/axxess-intelligence-page",
            "axxess-intelligence-page"
        ),
        nav: true,
        activationStrategy: "invoke-lifecycle",
        title: "Ask Axxess",
        settings: {
            menuName: "Ask Axxess",
            newRoute: true
        }
    }
];
